import { Handle, Position } from "@xyflow/react";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";

interface MonthGroupNodeData {
  bankId: string;
  month: string;
  label: string;
  count: number;
  totalAmount: number;
  unpaidAmount: number;
  expanded: boolean;
  onToggle?: (bankId: string, month: string) => void;
}

interface MonthGroupNodeProps {
  data: MonthGroupNodeData;
  isConnectable: boolean;
}

function MonthGroupNode({ data, isConnectable }: MonthGroupNodeProps) {
  const handleClick = () => {
    data.onToggle?.(data.bankId, data.month);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer rounded-lg bg-white p-3 shadow-md border-2 border-amber-300 hover:border-amber-500 transition-colors"
      style={{ minWidth: "180px" }}
    >
      <Handle
        type="target"
        position={Position.Left}
        id="left"
        style={{ background: "#f59e0b" }}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{ background: "#f59e0b" }}
        isConnectable={isConnectable}
      />

      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1">
          {data.expanded ? (
            <IconChevronDown size={16} className="text-amber-600" />
          ) : (
            <IconChevronRight size={16} className="text-amber-600" />
          )}
          <div className="font-bold text-sm text-amber-700">{data.label}</div>
        </div>
        <div className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-700">
          {data.count}
        </div>
      </div>
      <div className="mt-1 text-xs text-gray-600">
        應付總額: ${Math.round(data.totalAmount || 0).toLocaleString()}
      </div>
      <div className="text-xs text-red-500">
        未付: ${Math.round(data.unpaidAmount || 0).toLocaleString()}
      </div>
    </div>
  );
}

export default MonthGroupNode;
